import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import WillingToProvideCommercialGuarantorRuleset from '../../business/ruleset/solar_property/WillingToProvideCommercialGuarantorRuleset';

const { willingToProvideCommercialGuarantor } = loanFormModel.formField;

export class WillingToProvideCommercialGuarantorValidation
  implements ValidationSchema
{
  public name = willingToProvideCommercialGuarantor.name;
  public label = willingToProvideCommercialGuarantor.label;
  public type = 'string';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = WillingToProvideCommercialGuarantorRuleset;

  public when(schema: Yup.StringSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(
  new WillingToProvideCommercialGuarantorValidation()
);
